import { Link } from "gatsby";
import { Transition } from "@headlessui/react";
import { useContext, useEffect, useState } from "react";
import VisitMenu from "./../menu/menu-visit";
import AdmissionMenu from "./../menu/menu-admission";
import AcademicsMenu from "./../menu/menu-academics";
import StudentMenu from "./../menu/menu-student-life";
import WhyRollinsMenu from "./../menu/menu-why-rollins";
import ModalDefaults from "./../menu/menu-modal-defaults";
import { FaSearch } from "react-icons/fa";
import { openMenu } from "../service/headerService";
import { Logo } from "../logo";
import HamburgerSubMenu from "../menu/hamburger-sub-menu";
import { MenuContext } from "../../lib/store";

function Header({ cssClass, page, section }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isAdmissionMobile, setIsAdmission] = useState(false);
  const [isWhyRollinsMobile, setIsWhyRollins] = useState(false);
  const [isAcademicsMobile, setIsAcademics] = useState(false);
  const [isStudentMobile, setIsStudent] = useState(false);
  const [isVisitMobile, setIsVisit] = useState(false);
  const [isVisitMenu, toggleVisitMenu] = useState(false);
  const [isAdmissionMenu, toggleAdmissionMenu] = useState(false);
  const [isAcademicsMenu, toggleAcademicsMenu] = useState(false);
  const [isStudentMenu, toggleStudentMenu] = useState(false);
  const [isWhyRollinsMenu, toggleWhyRollinsMenu] = useState(false);
  const [isNewsMenu, toggleNewsMenu] = useState(false);
  const [isAthleticsMenu, toggleAthleticsMenu] = useState(false);
  const [header, setHeader] = useState("header");
  const [togglesOpen, setToggleOpen] = useState(false);
  const [visitMenuViewable, setVisitMenuViewable] = useState(false);

  const listenScrollEvent = () => {
    if (window.scrollY <= 30) {
      return setHeader("");
    }
    return setHeader("bg-blue-500 border-b-4 border-yellow-500 md:pt-3");
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent, false);
    listenScrollEvent();
    document.addEventListener("click", handleClickOutside);
  }, []);

  const handleClickOutside = (evt) => {
    if (
      !(
        evt.target.classList.contains("mega-menu") ||
        evt.target.closest(".mega-menu") ||
        evt.target.classList.contains("nav-item")
      )
    ) {
      // If mega menu is present click active mega menu nav item to toggle the close action
      if (document.querySelector(".mega-menu")) {
        document.querySelector(".nav-item.text-yellow-500")?.click();
      }
    }
  };

  function toggle(toggleFn, state, externalUrl) {
    //  to close previous menu
    if (!(openMenu.toggleFn === null && openMenu.state === null)) {
      openMenu.toggleFn(!openMenu.state);

      // to close menu of same type
      if (openMenu.toggleFn === toggleFn) {
        openMenu.toggleFn = null;
        openMenu.state = null;
        return;
      }
    }
    // to open current menu
    if (externalUrl !== undefined || toggleFn !== openMenu.toggleFn) {
      if (externalUrl === undefined && toggleFn !== openMenu.toggleFn) {
        toggleFn(state);
        openMenu.toggleFn = toggleFn;
        openMenu.state = state;
        setToggleOpen(true);
      } else {
        // go there: might not be necessary since
        // external link is a component
      }
    }
  }

  function pathStartsWith(path) {
    return (
      page !== undefined && page.path && page.path.indexOf(`/${path}`) === 0
    );
  }

  return (
    <>
      <header className={`fixed z-40 w-full lg:pt-3 ${header} ${cssClass}`}>
        <div className="flex flex-wrap justify-between max-w-6xl p-3 py-5 mx-auto">
          <a href="/college-of-liberal-arts">
            <p className="flex text-white no-underline">
              <Logo section={section} />
            </p>
          </a>
          <button
            className="flex items-center block px-3 py-2 text-white border border-white rounded lg:hidden"
            onClick={() => setIsOpen(!isOpen)}
          >
            <svg
              className="w-3 h-3 fill-current"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>

          <nav className="hidden lg:text-sm lg:mt-3 lg:ml-auto lg:flex lg:items-center lg:w-auto lg:relative">
            <a
              className={`${
                isWhyRollinsMenu || pathStartsWith("why-rollins")
                  ? `text-yellow-500`
                  : ``
              } nav-item nav-item--why-rollins flex cursor-pointer block mt-4 tracking-tight font-bold items-center text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-6`}
              onClick={() => {
                toggle(toggleWhyRollinsMenu, !isWhyRollinsMenu);
              }}
            >
              Why Rollins
            </a>
            <a
              className={`${
                isAcademicsMenu || pathStartsWith("academics")
                  ? `text-yellow-500`
                  : ``
              } nav-item nav-item--academics flex cursor-pointer block mt-4 tracking-tight font-bold items-center text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-6`}
              onClick={() => {
                toggle(toggleAcademicsMenu, !isAcademicsMenu);
              }}
            >
              Academics
            </a>
            <a
              className={`${
                isAdmissionMenu ||
                pathStartsWith("apply") ||
                pathStartsWith("scholarships-aid")
                  ? `text-yellow-500`
                  : ``
              } nav-item nav-item--admission-aid flex cursor-pointer block mt-4 tracking-tight font-bold items-center text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-6`}
              onClick={() => {
                toggle(toggleAdmissionMenu, !isAdmissionMenu);
              }}
            >
              Admission & Aid
            </a>
            <a
              className={`${
                isStudentMenu || pathStartsWith("student-life")
                  ? `text-yellow-500`
                  : ``
              } nav-item nav-item--student-life flex cursor-pointer block mt-4 tracking-tight font-bold items-center text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-6`}
              onClick={() => {
                toggle(toggleStudentMenu, !isStudentMenu);
              }}
            >
              Student Life
            </a>
            <a
              className={` ${
                isVisitMenu || pathStartsWith("visit") ? `text-yellow-500` : ``
              } nav-item nav-item--visit flex cursor-pointer block mt-4 tracking-tight font-bold items-center text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-6`}
              onClick={() => {
                toggle(toggleVisitMenu, !isVisitMenu);
                setVisitMenuViewable(true);
              }}
            >
              Visit
            </a>
            <a
              className={`${
                isAthleticsMenu ? `text-yellow-500` : ``
              } nav-item nav-item--athletics block mt-4 tracking-tight font-bold text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-6`}
              key="Athletics"
              href="/athletics"
              onClick={() => {
                toggleAthleticsMenu(true) && setToggleOpen(false);
              }}
              activeClassName={!togglesOpen ? "text-yellow-500" : ""}
              partiallyActive
            >
              Athletics
            </a>
            <a
              className={`${
                isNewsMenu ? `text-yellow-500` : ``
              } nav-item nav-item--news block mt-4 tracking-tight font-bold text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-6`}
              key="News"
              href="/college-of-liberal-arts/news"
              onClick={() => {
                toggleNewsMenu();
                setToggleOpen(false);
              }}
              activeClassName={!togglesOpen ? "text-yellow-500" : ""}
              partiallyActive
            >
              News
            </a>
            <a
              className="search cursor-pointer block mt-4 tracking-tight font-bold text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-8"
              onClick={() => setIsOpen(!isOpen)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                className="h-6 w-6 fill-current"
              >
                <path d="M17.545 15.467l-3.779-3.779a6.15 6.15 0 0 0 .898-3.21c0-3.417-2.961-6.377-6.378-6.377A6.185 6.185 0 0 0 2.1 8.287c0 3.416 2.961 6.377 6.377 6.377a6.15 6.15 0 0 0 3.115-.844l3.799 3.801a.953.953 0 0 0 1.346 0l.943-.943c.371-.371.236-.84-.135-1.211zM4.004 8.287a4.282 4.282 0 0 1 4.282-4.283c2.366 0 4.474 2.107 4.474 4.474a4.284 4.284 0 0 1-4.283 4.283c-2.366-.001-4.473-2.109-4.473-4.474z" />
              </svg>
            </a>
            <a
              className="hamburger cursor-pointer block mt-4 tracking-tight font-bold text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-3"
              onClick={() => setIsOpen(!isOpen)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                className="h-6 w-6 fill-current"
              >
                <path d="M16.4 9H3.6c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1h12.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1zm0 4H3.6c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1h12.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1zM3.6 7h12.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1H3.6c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1z" />
              </svg>
            </a>
          </nav>
        </div>
        {isVisitMenu && (
          <VisitMenu
            cssClass="mega-menu mega-menu--visit-menu"
            visibility={visitMenuViewable}
          />
        )}
        {isAdmissionMenu && (
          <AdmissionMenu cssClass="mega-menu mega-menu--admission-menu" />
        )}
        {isAcademicsMenu && (
          <AcademicsMenu cssClass="mega-menu mega-menu--academics-menu" />
        )}
        {isStudentMenu && (
          <StudentMenu cssClass="mega-menu mega-menu--student-menu" />
        )}
        {isWhyRollinsMenu && (
          <WhyRollinsMenu cssClass="mega-menu mega-menu--why-rollins-menu" />
        )}
      </header>
      <Transition show={isOpen}>
        <Transition.Child
          enter="transition ease-in-out duration-300 transform"
          enterFrom="translate-x-full"
          enterTo="translate-x-0"
          leave="transition ease-in-out duration-300 transform"
          leaveFrom="translate-x-0"
          leaveTo="translate-x-full"
          className="text-base z-50 overflow-x-hidden overflow-y-auto px-4 inset-y-0 right-0 bg-white fixed h-full hamburger-menu"
        >
          <div className="flex my-4 item-center">
            <button
              type="button"
              className="ml-auto"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span aria-hidden="true" className="block">
                <svg
                  className="h-8 w-8"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </span>
              <span className="hidden uppercase text-sm">Close</span>
            </button>
          </div>
          <div className="w-full mb-6">
            <form
              action="/search/"
              id="cse-search-box"
              role="search"
              className="flex flex-row border rounded border-gray-100 shadow"
            >
              <input
                name="cx"
                type="hidden"
                value="008993443446142021554:6alluroafgm"
              />
              <input name="cof" type="hidden" value="FORID:10" />
              <input name="ie" type="hidden" value="UTF-8" />
              <label className="sr-only" htmlFor="searchInput">
                Search
              </label>
              <input
                aria-describedby="buttonSearch"
                autoFocus
                aria-label="Search"
                className="w-full py-2 px-4 text-base"
                type="search"
                placeholder="Search rollins.edu"
                id="searchInput"
                name="q"
              />
              <span className="flex items-center">
                <button
                  aria-label="Search"
                  className="bg-teal-500 text-teal-900 p-3"
                  name="sa"
                  typ="submit"
                >
                  <FaSearch />
                </button>
              </span>
            </form>
          </div>
          <nav className="text-lg">
            <ul className="mb-6">
              <li className="my-1 relative lg:hidden">
                <a
                  className="cursor-pointer block py-1 tracking-tighter font-bold text-blue-500 hover:text-blue-800"
                  onClick={() => setIsWhyRollins(!isWhyRollinsMobile)}
                >
                  Why Rollins
                  <span className="absolute inset-y-0 right-0 flex items-center">
                    <svg
                      className="text-blue-500 h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </span>
                </a>
              </li>
              <li className="my-1 relative lg:hidden">
                <a
                  className="cursor-pointer block py-1 tracking-tighter font-bold text-blue-500 hover:text-blue-800"
                  onClick={() => setIsAcademics(!isAcademicsMobile)}
                >
                  Academics
                  <span className="absolute inset-y-0 right-0 flex items-center">
                    <svg
                      className="text-blue-500 h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </span>
                </a>
              </li>
              <li className="my-1 relative lg:hidden">
                <a
                  className="cursor-pointer block py-1 tracking-tighter font-bold text-blue-500 hover:text-blue-800"
                  onClick={() => setIsAdmission(!isAdmissionMobile)}
                >
                  Admission &amp; Aid
                  <span className="absolute inset-y-0 right-0 flex items-center">
                    <svg
                      className="text-blue-500 h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </span>
                </a>
              </li>
              <li className="my-1 relative lg:hidden">
                <a
                  className="cursor-pointer block py-1 tracking-tighter font-bold text-blue-500 hover:text-blue-800"
                  onClick={() => setIsStudent(!isStudentMobile)}
                >
                  Student Life
                  <span className="absolute inset-y-0 right-0 flex items-center">
                    <svg
                      className="text-blue-500 h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </span>
                </a>
              </li>
              <li className="my-1 relative lg:hidden">
                <a
                  className="cursor-pointer block py-1 tracking-tighter font-bold text-blue-500 hover:text-blue-800"
                  onClick={() => setIsVisit(!isVisitMobile)}
                >
                  Visit
                  <span className="absolute inset-y-0 right-0 flex items-center">
                    <svg
                      className="text-blue-500 h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </span>
                </a>
              </li>
              <li className="my-1 relative lg:hidden">
                <a
                  className="block cursor-pointer tracking-tighter font-bold text-blue-500 hover:text-blue-800"
                  key="Athletics"
                  href="/athletics"
                  activeClassName={
                    openMenu.state === null ? `text-yellow-500` : ``
                  }
                >
                  Athletics
                </a>
              </li>
              <li className="my-1 relative lg:hidden">
                <a
                  className="block cursor-pointer tracking-tighter font-bold text-blue-500 hover:text-blue-800"
                  key="News"
                  href="/college-of-liberal-arts/news"
                  activeClassName={
                    openMenu.state === null ? `text-yellow-500` : ``
                  }
                >
                  {" "}
                  News
                </a>
              </li>
            </ul>
            <ModalDefaults />
          </nav>
        </Transition.Child>
        <Transition.Child
          show={isOpen}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          className="fixed inset-0 z-40 w-screen h-screen bg-black bg-opacity-50"
          onClick={() => setIsOpen(!isOpen)}
        >
          <></>
        </Transition.Child>
      </Transition>
      {/* ADMISSION & AID */}
      <Transition
        show={isAdmissionMobile}
        enter="transition ease-in-out duration-300 transform"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
        className="text-base z-50 overflow-x-hidden overflow-y-auto px-4 inset-y-0 right-0 bg-white fixed h-full hamburger-menu"
      >
        <div className="flex my-4 item-center">
          <button
            type="button"
            className="mr-auto text-blue-500 items-center"
            aria-label="Back"
            onClick={() => setIsAdmission(!isAdmissionMobile)}
          >
            <span className="uppercase text-xs inline-flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M7 16l-4-4m0 0l4-4m-4 4h18"
                />
              </svg>{" "}
              Back to Main Menu
            </span>
          </button>
        </div>

        <HamburgerSubMenu
          primary={[
            { label: "Admission & Aid", url: "/apply" },
            { label: "Apply to Rollins", url: "/apply" },
            { label: "Early Decision", url: "/apply/early-decision" },
            {
              label: "Test Optional Admission",
              url: "/apply/test-optional-admission",
            },
            {
              label: "Connect With Your Counselor",
              url: "/apply/admission-counselors",
            },
          ]}
          secondary={[
            { label: "Financial Aid", url: "/scholarships-aid" },
            { label: "Scholarships", url: "/scholarships-aid/scholarships" },
            { label: "Grants", url: "/scholarships-aid/grants" },
            { label: "Loans", url: "/scholarships-aid/loans" },
            { label: "Work Study", url: "/scholarships-aid/work-study" },
            { label: "Tuition & Fees", url: "/scholarships-aid/tuition" },
            {
              label: "Net Price Calculator",
              url: "/scholarships-aid/net-price-calculator",
            },
            {
              label: "Financial Aid FAQs",
              url: "/scholarships-aid/frequently-asked-questions",
            },
          ]}
        />
      </Transition>
      {/* WHY ROLLINS */}
      <Transition
        show={isWhyRollinsMobile}
        enter="transition ease-in-out duration-300 transform"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
        className="text-base z-50 overflow-x-hidden overflow-y-auto px-4 inset-y-0 right-0 bg-white fixed h-full hamburger-menu"
      >
        <div className="flex my-4 item-center">
          <button
            type="button"
            className="mr-auto text-blue-500 items-center"
            aria-label="Back"
            onClick={() => setIsWhyRollins(!isWhyRollinsMobile)}
          >
            <span className="uppercase text-xs inline-flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M7 16l-4-4m0 0l4-4m-4 4h18"
                />
              </svg>{" "}
              Back to Main Menu
            </span>
          </button>
        </div>

        <HamburgerSubMenu
          primary={[
            { label: "Why Rollins?", url: "/why-rollins" },
            {
              label: "A Future Proof Foundation",
              url: "/why-rollins/future-proof-foundation",
            },
            {
              label: "Liberal Arts in Action",
              url: "/why-rollins/liberal-arts-in-action",
            },
            {
              label: "Mentorship, Mastered",
              url: "/why-rollins/mentorship-mastered",
            },
            { label: "Rollins Results", url: "/why-rollins/rollins-ready" },
            {
              label: "Finish in Four",
              url: "/why-rollins/finish-in-four-graduation-guarantee",
            },
          ]}
        />
      </Transition>
      {/* ACADEMICS */}
      <Transition
        show={isAcademicsMobile}
        enter="transition ease-in-out duration-300 transform"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
        className="text-base z-50 overflow-x-hidden overflow-y-auto px-4 inset-y-0 right-0 bg-white fixed h-full hamburger-menu"
      >
        <div className="flex my-4 item-center">
          <button
            type="button"
            className="mr-auto text-blue-500 items-center"
            aria-label="Back"
            onClick={() => setIsAcademics(!isAcademicsMobile)}
          >
            <span className="uppercase text-xs inline-flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M7 16l-4-4m0 0l4-4m-4 4h18"
                />
              </svg>{" "}
              Back to Main Menu
            </span>
          </button>
        </div>

        <HamburgerSubMenu
          primary={[
            { label: "Academics", url: "/academics" },
            { label: "Majors & Minors", url: "/academics/majors-minors" },
            {
              label: "Rollins Foundation in the Liberal Arts",
              url: "/academics/rollins-foundations-in-the-liberal-arts",
            },
            {
              label: "Rollins College Conference",
              url: "/academics/rollins-college-conference",
            },
            {
              label: "Personalized Learning Environment",
              url: "/academics/personalized-learning-environment",
            },
            { label: "Cool Classes", url: "/academics/cool-college-classes" },
            { label: "Great Guides", url: "/academics/faculty" },
            { label: "Study Abroad", url: "/academics/study-abroad" },
          ]}
          secondary={[
            {
              label: "Grand Challenges Scholar Program",
              url: "/academics/grand-challenges-scholars-program",
            },

            { label: "Honors Program", url: "/academics/honors-program" },
            {
              label: "Phi Beta Kappa",
              url: "/phi-beta-kappa",
            }, 
            {
              label: "Student-Faculty Collaborative Scholarship Program",
              url: "/academics/collaborative-research",
            },
            {
              label: "Women in Finance Program",
              url: "/academics/women-in-finance",
            },
                     
          ]}
        />
      </Transition>
      {/* STUDENT LIFE */}
      <Transition
        show={isStudentMobile}
        enter="transition ease-in-out duration-300 transform"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
        className="text-base z-50 overflow-x-hidden overflow-y-auto px-4 inset-y-0 right-0 bg-white fixed h-full hamburger-menu"
      >
        <div className="flex my-4 item-center">
          <button
            type="button"
            className="mr-auto text-blue-500 items-center"
            aria-label="Back"
            onClick={() => setIsStudent(!isStudentMobile)}
          >
            <span className="uppercase text-xs inline-flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M7 16l-4-4m0 0l4-4m-4 4h18"
                />
              </svg>{" "}
              Back to Main Menu
            </span>
          </button>
        </div>

        <HamburgerSubMenu
          primary={[
            { label: "Student Life", url: "/student-life" },
            {
              label: "Residential Life",
              url: "/student-life/residential-life",
            },
            {
              label: "Residence Hall Tours",
              url: "/student-life/residential-life/dorm-tours",
            },
            { label: "Campus Dining", url: "/student-life/campus-dining" },
            {
              label: "Diversity, Equity & Inclusion",
              url: "/student-life/diversity-equity-inclusion",
            },
            {
              label: "Career & Life Planning",
              url: "/student-life/career-life-planning",
            },
            {
              label: "Community Engagement",
              url: "/student-life/civic-engagement",
            },
            {
              label: "Student Organizations",
              url: "/student-life/student-organizations",
            },
            {
              label: "Campus Recreation & Intramurals",
              url: "/student-life/campus-recreation-intramurals",
            },
            {
              label: "Care, Health & Wellness",
              url: "/student-life/care-health-wellness",
            },
            { label: "Traditions", url: "/student-life/traditions" },
            {
              label: "#RollinsLife",
              url: "https://www.rollins.edu/rollinslife",
            },
          ]}
        />
      </Transition>
      {/* VISIT */}
      <Transition
        show={isVisitMobile}
        enter="transition ease-in-out duration-300 transform"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
        className="text-base z-50 overflow-x-hidden overflow-y-auto px-4 inset-y-0 right-0 bg-white fixed h-full hamburger-menu"
      >
        <div className="flex my-4 item-center">
          <button
            type="button"
            className="mr-auto text-blue-500 items-center"
            aria-label="Back"
            onClick={() => setIsVisit(!isVisitMobile)}
          >
            <span className="uppercase text-xs inline-flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M7 16l-4-4m0 0l4-4m-4 4h18"
                />
              </svg>{" "}
              Back to Main Menu
            </span>
          </button>
        </div>

        <HamburgerSubMenu
          primary={[
            { label: "Visit Rollins", url: "/visit" },
            { label: "In-Person Campus Tours", url: "/visit/campus-tours" },
            {
              label: "Connect With Us Virtually",
              url: "/visit/virtual-experiences",
            },
            {
              label: "Explore Rollins on Your Own",
              url: "/visit/virtual-tour",
            },
            { label: "Plan Your Visit", url: "/visit/plan-your-visit" },
          ]}
        />
      </Transition>
    </>
  );
}

export default Header;
